import * as angular from 'angular';
import {goHotKeysDef} from './hotkeys.factory';

export const goHotKeys = angular.module('go.hotkeys', [])
	.factory('Hotkeys', goHotKeysDef)
	.name;
